import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MAT_TOOLTIP_OPTIONS } from '@portal/data-access';
import { BytesizeIconPipe } from '@portal/pipe';
import { TimepickerModule } from '@shared/components/timepicker';
import { ToastModule } from '@shared/components/toast';
import { ParticipantApiService } from '../api/participant-api.service';
// import { DocumentEditorModule } from './document-editor/document-editor.module';
import { DocumentSigningSharedModule } from './document-signing-shared.module';
import { DocumentSigningComponent } from './document-signing.component';
import { documentSignRouting } from './document-signing.routing';
import { ParticipantFieldFormDialogComponent } from './participant-field-form-dialog/participant-field-form-dialog.component';
import { PdfViewerComponent } from '@core/pdf-viewer/feature';
import { SignatureBoxModule } from './signature-box/signature-box.module';
// import { SigningOnHtmlComponent } from './signing-on-html/signing-on-html.component';
import { SigningOnPdfComponent } from './signing-on-pdf/signing-on-pdf.component';
import { ViewDocumentComponent } from './view-document/view-document.component';
import { DatetimeModule } from '../pipes';
import { ErrorDialogComponent } from '@portal/dialog';

const pipes = [BytesizeIconPipe, DatetimeModule];

@NgModule({
  declarations: [
    DocumentSigningComponent,
    ViewDocumentComponent,
    SigningOnPdfComponent,
    // SigningOnHtmlComponent,
    ParticipantFieldFormDialogComponent,
  ],
  imports: [
    TimepickerModule,
    CommonModule,
    documentSignRouting,
    MatButtonModule,
    PdfViewerComponent,
    SignatureBoxModule,
    MatProgressBarModule,
    MatMenuModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    // DocumentEditorModule,
    // ContentBuilderModule,
    // PhoneNumberModule,
    // SharedComponentModule,
    // DirectivesModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatBottomSheetModule,
    MatBadgeModule,
    DocumentSigningSharedModule,
    ToastModule,
    ErrorDialogComponent,
    ...pipes,
  ],
  providers: [ParticipantApiService, { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: MAT_TOOLTIP_OPTIONS }],
})
export class DocumentSigningModule {}
